import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';

export const MODULE_NAME = 'VAT_CODES_SEARCH_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const GET_FIELDS = namespaced('GET_FIELDS');
const GET_FIELDS_OK = namespaced('GET_FIELDS_OK');
const GET_FIELDS_FAIL = namespaced('GET_FIELDS_FAIL');
const GET_RATES = namespaced('GET_RATES');
const GET_RATES_OK = namespaced('GET_RATES_OK');
const GET_RATES_FAIL = namespaced('GET_RATES_FAIL');
const GET_TRANSACTION_IDS = namespaced('GET_TRANSACTION_IDS');
const GET_TRANSACTION_IDS_OK = namespaced('GET_TRANSACTION_IDS_OK');
const GET_TRANSACTION_IDS_FAIL = namespaced('GET_TRANSACTION_IDS_FAIL');
const CLEAR_TRANSACTION_IDS = namespaced('CLEAR_TRANSACTION_IDS');
const CLEAR_RATES = namespaced('CLEAR_RATES');

export const ACTION_TYPES = {
  GET_FIELDS,
  GET_FIELDS_OK,
  GET_FIELDS_FAIL,
  GET_RATES,
  GET_RATES_OK,
  GET_RATES_FAIL,
  GET_TRANSACTION_IDS,
  GET_TRANSACTION_IDS_OK,
  GET_TRANSACTION_IDS_FAIL,
  CLEAR_TRANSACTION_IDS,
  CLEAR_RATES
};


export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case GET_FIELDS:
        return  Object.assign({}, state, {loading: true, error: null});
      case GET_FIELDS_OK:
        return Object.assign({}, state, {content: action.response, loading: false, error: null, progress: undefined});
      case GET_FIELDS_FAIL:
        return Object.assign({}, state, {content: undefined, loading: false, error: action.error});
      case GET_RATES:
        return  Object.assign({}, state, {loading: true, error: null});
      case GET_RATES_OK:
        return Object.assign({}, state, {rates: action.response, loading: false, error: null, progress: undefined});
      case CLEAR_RATES:
      case GET_RATES_FAIL:
        return Object.assign({}, state, {rates: undefined, loading: false, error: action.error});
      case GET_TRANSACTION_IDS:
        return  Object.assign({}, state, {loading: true, error: null});
      case GET_TRANSACTION_IDS_OK:
        return Object.assign({}, state, {transactionIds: action.response.transactions, loading: false, error: null, progress: undefined});
      case CLEAR_TRANSACTION_IDS:
      case GET_TRANSACTION_IDS_FAIL:
        return Object.assign({}, state, {transactionIds: undefined, loading: false, error: action.error});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {

  getVATRates: (country, effectiveDate) => {
    return (dispatch) => {
      log.debug('getVATRates');
      dispatch({type: GET_RATES});
      return CLIENT.getVATRates(country, effectiveDate)
        .then((response) => {
          log.debug('getRates: success: ', response);
          dispatch({type: GET_RATES_OK, response: response})
        })
        .catch((error) => {
          log.debug('getVATRates: failure: ', error);
          dispatch({type: GET_RATES_FAIL, failures: error})
        })
    }
  },
  getDropdownOptions: () => {
    return (dispatch) => {
     log.debug('getDropdownOptions');
      dispatch({type: GET_FIELDS});
     return CLIENT.getVATCodeSearchFields()
       .then((response) => {
         log.debug('getDropdownOptions: success: ', response);
         dispatch({type: GET_FIELDS_OK, response: response})
       })
       .catch((error) => {
         log.debug('getDropdownOptions: failure: ', error);
         dispatch({type: GET_FIELDS_FAIL, failures: error})
       })
    }
  },
  getTransactionIds: (params) => {
    return (dispatch) => {
      log.debug('getTransactionIds');
      dispatch({type: GET_TRANSACTION_IDS});
      return CLIENT.getVATCodeTransactionIds(params)
        .then((response) => {
          log.debug('getTransactionIds: success: ', response);
          dispatch({type: GET_TRANSACTION_IDS_OK, response: response})
        })
        .catch((error) => {
          log.debug('getTransactionIds: failure: ', error);
          dispatch({type: GET_TRANSACTION_IDS_FAIL, failures: error})
        })
    }
  },
  getTransactionIdsBySearch: (params) => {
    return (dispatch) => {
      log.debug('getTransactionIdsBySearch');
      dispatch({ type: GET_TRANSACTION_IDS });
      return CLIENT.getVATCodeTransactionIdsBySearch(params)
        .then((response) => {
          log.debug('getTransactionIdsBySearch: success: ', response);
          dispatch({
            type: GET_TRANSACTION_IDS_OK, response: {
              transactions: [response],
            }
          })
        })
        .catch((error) => {
          log.debug('getTransactionIdsBySearch: failure: ', error);
          dispatch({ type: GET_TRANSACTION_IDS_FAIL, failures: error })
        })
    }
  },

  getTransactionIdsByVatbox: (countryCode, boxValue, period, startDate) => {
    return (dispatch) => {

        log.debug('getTransactionIdsByVatbox');
      dispatch({ type: GET_TRANSACTION_IDS });
      return CLIENT.getVATCodeTransactionIdsByVatBox(countryCode, boxValue, period, startDate)
        .then((response) => {
          log.debug('getTransactionIdsByVatbox: success: ', response);
          dispatch({
            type: GET_TRANSACTION_IDS_OK, response: {
              transactions: response.transactions,
            }
          })
        })
        .catch((error) => {
          log.debug('getTransactionIdsByVatbox: failure: ', error);
          dispatch({ type: GET_TRANSACTION_IDS_FAIL, failures: error })
        })
    }
  },

  clearTransactionIds: () => {
    return (dispatch) => {
      dispatch({type: CLEAR_TRANSACTION_IDS});
    }
  },
  clearRates: () => {
    return (dispatch) => {
      dispatch({type: CLEAR_RATES});
    }
  }
};

export default API;